import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const rightsOffer: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'recordDate' },
            { type: 'field', field: 'adjustmentFactor' },
            { type: 'field', field: 'ccPrice' },
            { type: 'field', field: 'ccTerms' },
            { type: 'field', field: 'ccRatio' },
            { type: 'field', field: 'tradeStartDate' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'exDate' },
            { type: 'field', field: 'payDate' },
            { type: 'field', field: 'ccTicker2' },
            { type: 'field', field: 'stockTicker' },
            { type: 'field', field: 'ccCurrency' },
            { type: 'field', field: 'tradeEndDate' },
        ],
    },
];

export default rightsOffer;
